// src/components/common/ErrorState.tsx
import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';

type ErrorStateProps = {
  message: string;
};

export const ErrorState: React.FC<ErrorStateProps> = ({ message }) => {
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md">
        <div className="flex">
          <div className="flex-shrink-0">
            <AlertTriangleIcon className="h-5 w-5 text-red-500" />
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-red-800">Erro ao carregar dados</h3>
            <div className="mt-2 text-sm text-red-700">
              <p>{message}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorState;